import moment from "moment";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete, Box, DatePicker, Modal } from "@maysoft/common-component-react";

import Helpers from "commons/helpers";
import Strings from "constants/strings";
import ReportService from "services/medkit/report.service";

import { RootState } from "store";
import { CustomDateRangePicker } from "components";
import { setDataAlert, showLoading } from "store/slice/common.slice";


const reportService = new ReportService();

const ModalSummaryReportsLevels = ({
    open,
    setOpen,
}: {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
}) => {
    const dispatch = useDispatch();
    const dataMapCodenames = useSelector((state: RootState) => state.common.codenames);
    const [error, setError] = useState<{
        levelId?: string,
        dateTime?: string,
    }>({});
    const [data, setData] = useState<{
        endDate?: any,
        startDate?: any,
        levelId?: string,
    }>({
        startDate: moment().startOf("month").unix(),
        endDate: moment().endOf("month").unix(),
    });

    const handleValidateData = () => {
        let checked = true;
        let newErr: any = { ...error };
        if (Helpers.isNullOrEmpty(data?.levelId)) {
            checked = false;
            newErr["levelId"] = Strings.CHART.PLEASE_ENTER_REPORT_LEVEL;
        }
        if (
            !Helpers.isNullOrEmpty(data?.endDate) &&
            !Helpers.isNullOrEmpty(data?.startDate) &&
            (data?.endDate !== "0") && (data?.endDate !== 0) &&
            (data?.startDate !== "0") && (data?.startDate !== 0)
        ) {
            newErr["dateTime"] = undefined;
        } else {
            checked = false;
            newErr["dateTime"] = Strings.CHART.PLEASE_ENTER_DATE_TIME;
        }

        !checked && setError(newErr);

        return checked;
    };

    const handleSubmit = async () => {
        if (!handleValidateData()) {
            return;
        } else {
            try {
                dispatch(showLoading(true));

                const result = await reportService.generatingSynthesisReport({
                    endTime: data?.endDate,
                    startTime: data?.startDate,
                    levelReport: data?.levelId,
                });

                const reponseBlob = new Blob([result]);

                const fileName = `Bao cao cac cap.zip`;

                const downloadUrl = URL.createObjectURL(reponseBlob);

                const a = document.createElement("a");

                a.href = downloadUrl;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();

                URL.revokeObjectURL(downloadUrl);
                document.body.removeChild(a);
                dispatch(setDataAlert({ message: Strings.REPORT.EXPORT_FILE_REPORT_SUCCESS, type: "success" }));
            } catch (error) {
                const err = Helpers.handleExceptionError(error);
                !Helpers.isNullOrEmpty(err) && dispatch(setDataAlert({ message: err, type: "error" }));
            } finally {
                dispatch(showLoading(false));
            }
        }
    };

    return (
        <Modal
            fullWidth
            allowOutsideClick
            visible={open}
            maxWidth={"md"}
            hasActionButton
            onClose={() => {
                setOpen(false);
            }}
            onAction={() => {
                handleSubmit();
            }}
            buttonAction={Strings.COMMON.OK}
            closeButton={Strings.COMMON.CANCEL}
            title={Strings.CHART.CONDITIONS_FOR_REPORTING}
        >
            <Box sx={{ padding: "0px 16px" }}>
                <Grid container spacing={3} className="mt-3">
                    <Grid item xs={12}>
                        <Autocomplete
                            required
                            variant="outlined"
                            defaultValue={data?.levelId}
                            errorMessage={error?.levelId}
                            label={Strings.ANALYSIS.LEVEL_REPORT}
                            data={[...dataMapCodenames?.levelReport || []]}
                            placeholder={Strings.ANALYSIS.SELECT_LEVEL_REPORT}
                            onChange={(val: any) => {
                                setData(prev => ({
                                    ...prev,
                                    levelId: val,
                                }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <DatePicker
                            label="Từ"
                            placeholder="Nhập thời gian"
                            value={Helpers.toUnix(data?.startDate)}
                            onChangeValue={(value) => {
                                const val = !Helpers.isNullOrEmpty(value) ? moment(value).startOf("day").unix() : undefined;
                                setData(prev => ({
                                    ...prev,
                                    startDate: val,
                                }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <DatePicker
                            label="Đến"
                            placeholder="Nhập thời gian"
                            value={Helpers.toUnix(data?.endDate)}
                             onChangeValue={(value) => {
                                const val = !Helpers.isNullOrEmpty(value) ? moment(value).endOf("day").unix() : undefined;
                                setData(prev => ({
                                    ...prev,
                                    endDate: val,
                                }));
                            }}
                        />
                    </Grid>
                    {/* <Grid item xs={12}>
                        <CustomDateRangePicker
                            required
                            errorMessage={error?.dateTime}
                            label={Strings.COMMON.DATETIME}
                            value={{
                                endDate: Helpers.toUnix(data?.endDate),
                                startDate: Helpers.toUnix(data?.startDate),
                            }}
                            onChangeValue={(value) => {
                                setData(prev => ({
                                    ...prev,
                                    endDate: value?.endDate,
                                    startDate: value?.startDate,
                                }));
                            }}
                        />
                    </Grid> */}
                </Grid>
            </Box>
        </Modal>
    );
};


export default ModalSummaryReportsLevels;